/* Cart trigger updated to match the outlined Buitn Planten header action style. */
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import CartDrawer from './CartDrawer';

export default function CartButton() {
  const { itemCount } = useCart();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Open winkelwagen"
        className="relative flex h-[25px] w-[28px] items-center justify-center text-[#1a1a1a] transition-colors hover:text-[#1e2b22]"
        onClick={() => setIsDrawerOpen(true)}
      >
        <ShoppingCart className="h-[23px] w-[23px]" strokeWidth={1.35} />
        <AnimatePresence>
          {itemCount > 0 && (
            <motion.span
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="absolute -right-2 -top-2 flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-[#1e2b22] px-1 text-[9px] font-semibold text-white"
            >
              {itemCount > 99 ? '99+' : itemCount}
            </motion.span>
          )}
        </AnimatePresence>
      </button>
      <CartDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </>
  );
}
